const pending = new Map();
const resolved = new Map();
const DEFAULT_TTL = 15000; // 15s cache window per request

const makeKey = (url, options = {}) => {
    const method = (options.method || 'GET').toUpperCase();
    const auth = options.headers?.Authorization || options.headers?.authorization || '';
    return `${method}:${auth}:${url}`;
};

export const fetchSolicitudesCached = (url, options = {}, { ttl = DEFAULT_TTL } = {}) => {
    const key = makeKey(url, options);
    const now = Date.now();

    const cached = resolved.get(key);
    if (cached && now - cached.timestamp < ttl) {
        return Promise.resolve(cached.data);
    }

    if (pending.has(key)) {
        return pending.get(key);
    }

    const request = fetch(url, options)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            resolved.set(key, { data, timestamp: Date.now() });
            pending.delete(key);
            return data;
        })
        .catch((err) => {
            pending.delete(key);
            resolved.delete(key);
            throw err;
        });

    pending.set(key, request);
    return request;
};

export const invalidateSolicitudesCache = (matcher) => {
    const shouldDrop =
        typeof matcher === 'function'
            ? matcher
            : matcher
                ? (key) => key.includes(String(matcher))
                : () => true;

    for (const key of pending.keys()) {
        if (shouldDrop(key)) pending.delete(key);
    }
    for (const key of resolved.keys()) {
        if (shouldDrop(key)) resolved.delete(key);
    }
};
